'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/Workflows';
const INIT_STATE = {
  workflows: [],
  requestState: RequestState.NOT_REQUESTED
};
export function workflows(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_WORKFLOWS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_WORKFLOWS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_WORKFLOWS:
      return Object.assign({}, state, {
        workflows: action.workflows.workflows
      });
    case Actions.FAIL_GETTING_WORKFLOWS:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
}